import { render, staticRenderFns } from "./addQuestions.vue?vue&type=template&id=6f9a37a8"
import script from "./addQuestions.vue?vue&type=script&lang=js"
export * from "./addQuestions.vue?vue&type=script&lang=js"
import style0 from "./addQuestions.vue?vue&type=style&index=0&id=6f9a37a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports